<template>
    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange">
        <Clecture :navsub="11" :options="c_myoption" v-if="isload"></Clecture>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'mylecture',
        mixins: [mixinmember],
        components: {
            Clecture: () => import('@/components/Clecture')
        },
        data() {
            return {
                curnavkv: 25
            };
        },
        computed: {

            c_options: function () {
                let _options = { 'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': true, 'anycourse': true };
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 4;
                return _myoption;
            }
        }
    }
</script>
